import React, { useEffect } from 'react';
import ReactGA from 'react-ga';

const routeTrackerWrapper = ({WrappedComponent, options = {}, url}) => {
  const trackPage = (pageUrl,history) => {
    const { component } = options;
    const pageView = component ? url : pageUrl;
    ReactGA.pageview(pageView);
  };
  const HOC = props => {
    useEffect(() => trackPage(props.history.location.pathname,props.history), [
      props.history.location.pathname,
    ]);
    return <WrappedComponent {...props} />;
  };
  return HOC;
};

export default routeTrackerWrapper;
